import React from 'react';
import Container from '../../../containers/system/roles/showRoleContainer';

export default function () {
  return (
    <Container />
  );
}
